// Module
var code = "<span *ngIf=\"workSessionCounter.count > 0\" class=\"float-right badge badge-success mx-1\">{{workSessionCounter.count}}</span>";
// Exports
module.exports = code;